// Figma High Fidelity 2.0, node 79089:811961's six chart colors, with Inward
// and POS pinned to the red and the teal/green already in that set rather
// than any new color. The rest cycle through what's left, in the same order
// getChartEntryColor uses them.
const INWARD_COLOR = "#B62217";
const POS_COLOR = "#0F766E";
const OTHER_COLORS = ["#AFAFAE", "#496786", "#88651F", "#746080"];

/**
 * Whether a payment method label has its own fixed color (Inward, POS) and
 * so should be left out of the fallback palette's running index.
 * @param {string} label The payment method's display label.
 * @returns {boolean} True when the label has a fixed color.
 */
export function isReservedPaymentMethodColor(label: string): boolean {
  const lower = label.toLowerCase();
  return lower.includes("inward") || lower.startsWith("pos");
}

/**
 * The color for a payment method slice on the "Sales by Payment Method"
 * charts. Inward (transfer) is always the design's red, POS is always its
 * teal/green; every other method cycles through the remaining four colors
 * from that same set, indexed by its own position among the non-reserved
 * methods so the two fixed colors are never reused elsewhere.
 * @param {string} label The payment method's display label.
 * @param {number} fallbackIdx The entry's position among the non-reserved methods.
 * @returns {string} A color hex code.
 */
export function getPaymentMethodColor(
  label: string,
  fallbackIdx: number
): string {
  if (label.toLowerCase().includes("inward")) return INWARD_COLOR;
  if (label.toLowerCase().startsWith("pos")) return POS_COLOR;

  return OTHER_COLORS.at(fallbackIdx) || "";
}
